export default class FormNumber {
    static init(): void {
        const formNumbers = document.querySelectorAll('.form-number');

        formNumbers.forEach((formNumber) => {
            const input = formNumber.querySelector('input');
            const minus = formNumber.querySelector('.form-number__minus');
            let plus = formNumber.querySelector('.form-number__plus');

            if (!input || !minus || !plus) {
                return;
            }

            minus.addEventListener('click', () => {
                let value = parseInt(input.value);
                if (value > 1) {
                    value--;
                    input.value = value.toString();
                    animation(input);
                }

                if (minus.classList.contains('form-number__control-item')) {
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });

            plus.addEventListener('click', () => {
                let plus = formNumber.querySelector('.form-number__plus') as HTMLFormElement;
                if (plus.classList.contains('form-number__plus--disabled')) {
                    return;
                }

                let value = parseInt(input.value);
                value++;
                input.value = value.toString();
                animation(input);

                if (plus.classList.contains('form-number__control-item')) {
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            });
        });

        function animation(input: HTMLInputElement) {
            input.animate([
                {transform: 'scale(1)'},
                {transform: 'scale(1.3) translateX(3px)'},
                {transform: 'scale(1)'},
            ], {
                duration: 200,
                easing: 'ease-in-out',
            });

        }
    }
}
